import {
  Component,
  Input,
  Output,
  EventEmitter,
  Type,
  ViewContainerRef,
  ViewChild,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  @Input() title: string | null = null;
  @Input() textContent: string | null = null;
  @Input() componentContent: Type<any> | null = null;
  @Input() confirmButtonText: string | null = null;
  @Input() saveButtonText: string | null = null;

  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  @ViewChild('modalContentContainer', { read: ViewContainerRef, static: true })
  modalContentContainer!: ViewContainerRef;

  private contentInstance: any = null;

  constructor() {}

  ngAfterViewInit() {
    this.renderContent();
  }

  ngOnDestroy() {
    this.modalContentContainer.clear();
  }

  onSave(): void {
    if (this.contentInstance && typeof this.contentInstance.save === 'function') {
      this.contentInstance.save();
    }
  }

  private renderContent() {
    if (this.componentContent) {
      const ref = this.modalContentContainer.createComponent(this.componentContent);
      this.contentInstance = ref.instance;
    }
  }
}
